import{IconDash200 as e}from"../src/elements/IconDash200.js";customElements.define("sp-icon-dash200",e);
//# sourceMappingURL=sp-icon-dash200.js.map
